/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

/**
 * 流入元プレイリスト（関連動画付きページの `?from=`）。個別動画ページは未指定
 * @nullable
 */
export type VideoSurveyResponseInputScenarioId = Cuid | null
